<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Edit'
}
</script>

<style></style>
